import React from 'react';
import { Alert } from 'reactstrap';

import GameList from '../Games/GameList';

class Dashboard extends React.Component {

    render(){
        return (
            <div>
                <Alert color="primary">
                Please send etransfer to admin@tbayshinny.com to purchase credits. We will make every effort to update your account ASAP: 1 Game - $16, 3 Games - $45, 5 Games - $70, 10 Games - $130
                </Alert>
                <GameList />
            </div>
        );
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js